/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useFormatters } from "../../hooks/useFormatters";

const FormatPrice = ({ value, currency }) => {
  const { FormatPrice } = useFormatters();

  return FormatPrice({ value, currency });
};

export default FormatPrice;
